import React,{useEffect} from 'react'
import './InnerTermsConditions.css'
import YellowFilledRoundBtn from '../../Common-Component/Common_Btn/YellowFilledRoundBtn/YellowFilledRoundBtn'
import OrangeFilledRoundBtn from '../../Common-Component/Common_Btn/OrangeFilledRoundBtn/OrangeFilledRoundBtn'
import { getTerms_and_Conditions } from '../../../features/terms_conditions.js/Slice'
import parse from "html-react-parser";
import { useDispatch, useSelector } from "react-redux";

const InnerTermsConditions = () => {

    const termsconditions = useSelector((state) => state.termsconditions.addTermsConditions);
    const dispatch = useDispatch();
   

   useEffect(() => {
         dispatch(getTerms_and_Conditions());
       }, [dispatch]);

    return (
        <section className='InnerPolicy'>
            <p className='policy_decsn_text'> {termsconditions.description ? parse(termsconditions.description) : ""}   </p>


            {/* <p className='policy_light_heading'>1. Definitions</p>

            <p className='policy_decsn_text'>
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
            </p>

            <p className='policy_decsn_text'>
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
            </p>

            <p className='policy_decsn_text'>
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
            </p>

            <p className='policy_light_heading'>2. Privacy</p>

            <p className='policy_decsn_text'>
                You have the option to: (1) opt out of receiving promotional materials via mail, phone, or email; (2) access, review, verify, update, or rectify your personal Information; or (3) deactivate your account. To exercise any of these options, just get in touch with MCW, as detailed herein. You can unsubscribe from marketing emails by visiting the Communication Preferences page.
            </p>


            <p className='policy_light_heading'>3. Orders</p>


            <p className='policy_decsn_text'>
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a
                type specimen book. It has survived not only five centuries, but also the leap into electronic types- etting, remaining essentially unchanged. It was
                popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like
                Aldu PageMaker including versions of Lorem Ipsum.
            </p>

            <p className='policy_decsn_text'>
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a
                type specimen book. It has survived not only five centuries, but also the leap into electronic types- etting, remaining essentially unchanged. It was
                popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like
                Aldu PageMaker including versions of Lorem Ipsum.
            </p>

            <p className='policy_light_heading'>4. Payment</p>

            <p className='policy_decsn_text'>
                The customer will complete payment upon placing the order, which includes taxes and shipping charges. Payments are handled by Mansa NUtri's third-- party payment processor, & the customer is accountable for reviewing all relevant terms and policies. Mansa Nutri bears no responsibility for the actions or oversights of the payment processing entity.
            </p> */}

            {/* <div className='footer_btn_holder'>
                <div className='yellow_btn_holder'>
                    <YellowFilledRoundBtn btnText={"Decline"} />
                </div>

                <div className='orange_btn_holder'>
                    <OrangeFilledRoundBtn btnText={"Accept"} />
                </div>
            </div> */}

        </section>
    )
}

export default InnerTermsConditions
